<div class="progress" id="pre-loader-bar">
	<div class="indeterminate"></div>
</div>
